var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepwiseFeatureSelectionOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V14C20 12.8954 19.1046 12 18 12L2 12C0.89543 12 0 12.8954 0 14V15C0 16.1046 0.89543 17 2 17H18C19.1046 17 20 16.1046 20 15Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15V14C19.5 13.1716 18.8284 12.5 18 12.5L2 12.5C1.17157 12.5 0.5 13.1716 0.5 14V15C0.5 15.8284 1.17157 16.5 2 16.5H18C18.8284 16.5 19.5 15.8284 19.5 15Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9V8C16 6.89543 15.1046 6 14 6L2 6C0.895431 6 0 6.89543 0 8V9C0 10.1046 0.895431 11 2 11H14C15.1046 11 16 10.1046 16 9Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9V8C15.5 7.17157 14.8284 6.5 14 6.5L2 6.5C1.17157 6.5 0.5 7.17157 0.5 8V9C0.5 9.82843 1.17157 10.5 2 10.5H14C14.8284 10.5 15.5 9.82843 15.5 9Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3V2C13 0.89543 12.1046 0 11 0L2 0C0.895431 0 0 0.89543 0 2V3C0 4.10457 0.895431 5 2 5L11 5C12.1046 5 13 4.10457 13 3Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3V2C12.5 1.17157 11.8284 0.5 11 0.5L2 0.5C1.17157 0.5 0.5 1.17157 0.5 2V3C0.5 3.82843 1.17157 4.5 2 4.5L11 4.5C11.8284 4.5 12.5 3.82843 12.5 3Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepwiseFeatureSelectionOperationIcon);
export default __webpack_public_path__ + "static/media/StepwiseFeatureSelectionOperationIcon.6a22e55ed6ea58ce36258b438a0eb9c6.svg";
export { ForwardRef as ReactComponent };